import { AbstractDTO } from "./abstract";

export enum GalleryItemType {
	IMAGE = 'Image',
	YOU_TUBE = 'YouTube',
    VIDEO = 'Video',
}

export class GalleryItemDTO extends AbstractDTO  {
	type: string;
    src: string;
	thumb: string;
	poster: string;
    modal: string;
    title: string;
	description: string;
    subTitle: string;
	label: string;
	showInGallery: boolean;
	link: string;
    entityBlock: string;
    gridArea: string;
    alternative: string;
    file_path: string;
    filename: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        Object.assign(this, attributes);
        this.type = attributes['type'] || attributes['image_type'];
        if(this.type == GalleryItemType.YOU_TUBE) {
			attributes['src'] = 'https://www.youtube.com/embed/' + attributes['file_path'];
			attributes['thumb'] = 'http://img.youtube.com/vi/' + attributes['file_path'] +'/hqdefault.jpg';
		} else if(attributes['file_path']) {
			attributes['src'] = `${attributes['file_path']}/${attributes['filename_display']}`;
			attributes['thumb'] = attributes['src'].replace('.' + attributes['file_extension'], '') + '_Sma.jpg';
			attributes['poster'] = attributes['src'].replace('.' + attributes['file_extension'], '') + '_Big.jpg';
			attributes['modal'] = attributes['src'].replace('.' + attributes['file_extension'], '') + '_Enlarge.jpg';
        }
        this.src =  attributes['src'] || "";
        this.thumb = attributes['thumb'] || "";
        this.poster = attributes['poster'] || "";
        this.modal = attributes['modal'] || this.poster || "";
        this.title = attributes['title'] || attributes['property_2'];
        this.description = attributes['description'] || attributes['property_2'];
        this.subTitle = attributes['subTitle'] || "";
        this.label = attributes['label']  || attributes['property_4'];
        this.showInGallery = attributes['showInGallery']  || attributes['show_in_gallery'] != '0' || false;
        this.link = attributes['gallery_link'] || "";
        this.entityBlock = attributes['gallery_entity_block'] || "";
        this.gridArea = attributes['drawing_key'] || "";
        this.alternative = attributes['alternative'] || "";
        this.file_path = attributes['file_path'] || "";
        this.filename = attributes['filename'] || "";
    }

}
